import * as React from 'react';
import withIconSvg from '../helpers/withIconSvg';

const Icon: React.FC = (props) => (
	<svg
		width="52"
		height="28"
		viewBox="0 0 52 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<rect x="1" y="0.5" width="50" height="27" rx="13.5" fill="#86E4E9"/>
		<rect x="1" y="0.5" width="50" height="27" rx="13.5" stroke="#0CAEB7"/>
		<path d="M17.513 13.709H18.2103C18.862 13.709 19.3496 13.5814 19.6732 13.3262C19.9968 13.0664 20.1586 12.6904 20.1586 12.1982C20.1586 11.7015 20.0218 11.3346 19.7484 11.0977C19.4795 10.8607 19.0557 10.7422 18.4769 10.7422H17.513V13.709ZM22.2982 12.123C22.2982 13.1986 21.961 14.0212 21.2865 14.5908C20.6166 15.1605 19.6618 15.4453 18.4222 15.4453H17.513V19H15.3939V9.00586H18.5863C19.7985 9.00586 20.7191 9.2679 21.348 9.79199C21.9815 10.3115 22.2982 11.0885 22.2982 12.123ZM28.1465 11.2139C28.429 11.2139 28.6637 11.2344 28.8506 11.2754L28.6934 13.2305C28.5247 13.1849 28.3197 13.1621 28.0781 13.1621C27.4128 13.1621 26.8932 13.333 26.5195 13.6748C26.1504 14.0166 25.9658 14.4951 25.9658 15.1104V19H23.8809V11.3574H25.46L25.7676 12.6426H25.8701C26.1071 12.2142 26.4261 11.8701 26.8271 11.6104C27.2327 11.346 27.6725 11.2139 28.1465 11.2139ZM32.5182 19.1367C31.6204 19.1367 30.914 18.7881 30.3991 18.0908C29.8886 17.3936 29.6334 16.4274 29.6334 15.1924C29.6334 13.9391 29.8932 12.9639 30.4127 12.2666C30.9368 11.5648 31.6569 11.2139 32.5729 11.2139C33.5345 11.2139 34.2682 11.5876 34.7741 12.335H34.8424C34.7376 11.7653 34.6852 11.2572 34.6852 10.8105V8.36328H36.777V19H35.1774L34.7741 18.0088H34.6852C34.2112 18.7607 33.4889 19.1367 32.5182 19.1367ZM33.2496 17.4756C33.7829 17.4756 34.1725 17.3206 34.4186 17.0107C34.6692 16.7008 34.806 16.1745 34.8288 15.4316V15.2061C34.8288 14.3857 34.7011 13.7979 34.4459 13.4424C34.1953 13.0869 33.7851 12.9092 33.2155 12.9092C32.7506 12.9092 32.3883 13.1074 32.1286 13.5039C31.8733 13.8958 31.7457 14.4678 31.7457 15.2197C31.7457 15.9717 31.8756 16.5368 32.1354 16.915C32.3952 17.2887 32.7666 17.4756 33.2496 17.4756Z" fill="#002838"/>
	</svg>
);

export default withIconSvg(
	Icon,
	false,
	{
		tags: [
			'environment',
			'production',
			'badge',
			'unicorn',
		],
	},
);
